<template>
    <div id="produk">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Pembayaran',
                    href: '#/produk',
                    exact: true,
                },
                { text: 'Paket' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Paket Belajar</h3>

        <v-card flat>
            <v-card-title>
                Daftar Paket
                <v-spacer></v-spacer
                ><v-btn
                    class="align-center text-body-2 blew white--text"
                    text
                    @click="createProduk()"
                    ><v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Paket
                </v-btn>
            </v-card-title>

            <v-divider />

            <app-datatable
                :items="produkList"
                :headers="headers"
                :hasAction="true"
                :has-custom-pagination="false"
                :custom-pagination-total-items="produkList.length"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="pagination.totalPages"
                :custom-pagination-sort-mode="pagination.sortMode"
                v-on:selected="selectedRow = $event"
                :loading="isLoading"
                v-on:dblClicked="updateProduk()"
                v-on:deleted="confirmDelete($event)"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = { query: $event.value, by: headersKey[$event.key] }
                "
            ></app-datatable>
        </v-card>

        <v-dialog v-model="dialogConfirm.open" persistent max-width="450">
            <dialog-confirm
                :title="dialogConfirm.title"
                :subtitle="dialogConfirm.subtitle"
                @close="
                    dialogConfirm.open = false;
                    dialogConfirm.title = null;
                    dialogConfirm.function = null;
                "
                @confirm="
                    deleteProduk(dialogConfirm.function);
                    dialogConfirm.open = false;
                    dialogConfirm.title = null;
                    dialogConfirm.function = null;
                "
            />
        </v-dialog>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import SalesService from "@/modules/global/services/sales.js";
import Spinner from "@/modules/global/components/plugins/Spinner";
import DialogConfirm from "@/modules/global/components/DialogConfirm";

export default {
    name: "produk",

    components: {
        "app-datatable": DataTable,
        "app-spinner": Spinner,
        "dialog-confirm": DialogConfirm,
    },

    data: function () {
        return {
            isLoading: false,
            produkList: [],
            status: {
                PUBLISH: "PUBLISHED",
                UNPUBLISH: "UNPUBLISHED",
            },
            selectedRow: null,
            search: null,
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            headers: [
                { text: "Paket ID", value: "id", width: 100 },
                { text: "Nama", value: "name", width: 300 },
                { text: "Jenjang", value: "level" },
                { text: "Grade", value: "grade" },
                { text: "Jenis", value: "package_type" },
                { text: "Actual Price", value: "actual_price" },
                { text: "Aktif", value: "is_show", width: 80 },
                { text: "Aksi", value: "actions" },
            ],
            headersKey: [
                "id",
                "name",
                "level",
                "grade",
                "type",
                "actual_price",
            ],
            dialogConfirm: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
        };
    },

    mounted: function () {
        this.fetchData();
    },

    watch: {
        pagination: function () {
            this.fetchData();
        },
    },

    methods: {
        fetchData: function () {
            var context = this;

            this.isLoading = true;
            SalesService.getPaket(function (result) {
                context.produkList = [];

                if (result.success) {
                    result.data.forEach(function (content, index) {
                        const gpackage = content.grade_package;
                        // .toString()
                        // .replace(/[\[\]']+/g, "");
                        var row = {
                            no: index,
                            id: content.id,
                            name: content.name,
                            level: content.level,
                            grade: content.type === "QUOTA" ? "ALL" : gpackage,
                            package_type: content.type,
                            consul_session:
                                content.type === "QUOTA"
                                    ? content.addon_value
                                    : content.consul_session,
                            actual_price: context.convertToRupiah(
                                content.actual_price
                            ),
                            is_show: content.is_show,
                        };

                        if (content.is_active) {
                            context.produkList.push(row);
                        }

                        context.produkList = _.orderBy(
                            _.filter(context.produkList, {}),
                            ["sequence"],
                            ["asc"]
                        );
                    });
                    context.isLoading = false;
                } else {
                    alert("Terjadi kesalahan : " + result.message);
                    context.isLoading = false;
                }
            });
        },

        createProduk: function () {
            this.$router.push({ path: "/produk/form" });
        },

        updateProduk: function () {
            var produkId = this.selectedRow.id;
            this.$router.push({
                path: "/produk/form",
                query: { id: produkId },
            });
        },

        updateAllProdukStatus: function (status) {
            var context = this;
            var confirmed = window.confirm(
                "Apakah anda yakin akan mengupdate semua status produk?"
            );

            if (confirmed) {
                this.isLoading = true;
                SalesService.updateAllProdukStatus(status, function (result) {
                    context.isLoading = false;

                    if (result.success) {
                        alert("Data Terupdate");
                        context.fetchData();
                    } else {
                        alert("Terjadi Kesalahan : " + result.message);
                    }
                });
            }
        },

        confirmDelete: function (produk) {
            this.dialogConfirm.title = "Hapus Paket Belajar?";
            this.dialogConfirm.subtitle =
                "Apakah Anda yakin akan menghapus paket belajar ini?";
            this.dialogConfirm.function = produk;
            this.dialogConfirm.open = true;
        },

        deleteProduk: function (produk) {
            var context = this;
            var produkId = produk.id;

            SalesService.hapusPaket(produkId, function (result) {
                context.isLoading = false;
                if (result.success) {
                    context.$store.commit("showAlert", {
                        message: `Data Terhapus`,
                        type: "success",
                    });
                    context.fetchData();
                } else {
                    context.$store.commit("showAlert", {
                        message: `Data gagal terhapus`,
                        type: "error",
                    });
                }
                return;
            });

            this.dialogConfirm.open = false;
            this.dialogConfirm.title = null;
            this.dialogConfirm.function = null;
        },

        convertToRupiah: function (value) {
            var rupiah = "";
            var angkarev = value.toString().split("").reverse().join("");

            for (var i = 0; i < angkarev.length; i++)
                if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
            return (
                "Rp " +
                rupiah
                    .split("", rupiah.length - 1)
                    .reverse()
                    .join("")
            );
        },
    },
};
</script>



// WEBPACK FOOTER //
// Produk.vue?73629c1d